/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ExpandVerticalIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ExpandVerticalIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M5.85353 6.85351L8.49998 4.20706L11.1464 6.85351L11.8535 6.1464L8.49998 2.79285L5.14642 6.1464L5.85353 6.85351Z"
              fill="currentColor"
            />
            <path
              d="M5.85353 9.1464L8.49998 11.7928L11.1464 9.1464L11.8535 9.85351L8.49998 13.2071L5.14642 9.85351L5.85353 9.1464Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ExpandVerticalIcon.tags = [
  'enlarge',
  'arrow',
  'caret',
  'up',
  'down',
  'double-arrow',
  'expand',
];

ExpandVerticalIcon.category = 'General Icons';

ExpandVerticalIcon.iconSize = 16;
